import { APIData, appFetch } from ".";

export interface Partner {
  id: number;
  name: string;
  image: string;
}

export const partnersAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Partner[]>>("/partners?page=" + page);
  },
};
